var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForceEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5563 10.1234L13.8361 6.44169L15.0616 5.21447L16.2868 3.99805L17.5344 5.21447L18.7598 6.44169L20.0015 7.65376L18.8036 8.87422L17.5563 10.1234Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.28 6.9821L17.0001 10.7076L7.72583 19.9994H4.00146V16.2899L13.28 6.9821ZM6.97759 18.3996H5.60122V17.019L13.1509 9.45846L13.8824 10.1106L14.5273 10.6857L6.97759 18.3996Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForceEdit);
export default __webpack_public_path__ + "static/media/ForceEdit.69cbf721e4ac165308abefefcaa0c371.svg";
export { ForwardRef as ReactComponent };